export enum NotificationType {
    new = 'NEW',
    expiring = 'EXPIRING',
    nonCompliant = 'NON_COMPLIANT',
    newEntity = 'NEW_ENTITY_BODY',
    compliant = 'COMPLIANT',
}

export interface NotificationConfiguration {
    summaryTemplate: string;
    descriptionTemplate: string;
    initEnabled: boolean;
    remindersEnabled: boolean;
}

export interface NotificationConfigurationsResponse {
    notifications: Record<NotificationType, NotificationConfiguration>;
}

// Notification types that are one-shot and carry no reminder cadence, so callers reasoning about
// enablement must not treat a false `remindersEnabled` as "off".
const reminderlessNotificationTypes = [
    NotificationType.compliant,
] as const;

export type ReminderlessNotificationType = typeof reminderlessNotificationTypes[number];

export const REMINDERLESS_NOTIFICATION_TYPES: ReadonlySet<NotificationType> =
    new Set(reminderlessNotificationTypes);

export function isReminderlessNotificationType(type: NotificationType): type is ReminderlessNotificationType {
    return REMINDERLESS_NOTIFICATION_TYPES.has(type);
}
